// Update your existing api.js with these changes
import env from '../config/env';

const apiService = {
  submitForm: async (formType, formData) => {
    try {
      const response = await fetch(`${env.apiUrl}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Add any API key if required
          // 'x-api-key': 'your-api-key',
        },
        body: JSON.stringify({
          formType,
          ...formData
        }),
        // Explicitly request CORS
        mode: 'cors',
        credentials: 'omit'
      });
      
      // Handle non-JSON responses
      if (!response.ok) {
        const errorText = await response.text();
        try {
          // Try to parse as JSON
          const errorData = JSON.parse(errorText);
          throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
        } catch (e) {
          // If parsing fails, use the raw text
          throw new Error(`Error ${response.status}: ${errorText || response.statusText}`);
        }
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Form submission error:', error);
      throw error;
    }
  }
};

export default apiService;
